<h1 mat-dialog-title>Please enter your password.</h1>
<div mat-dialog-content>
    <div class="row">
        <div class="col">
            <mat-form-field appearance="outline">
                <mat-label>Password</mat-label>
                <input matInput  [(ngModel)]="password" type="password">
              </mat-form-field>
        </div>
    </div>
  <br>
  <br>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onNoClick()">Close</button>&nbsp;
  <button mat-raised-button color="primary" (click)="getToken()" cdkFocusInitial>Submit</button>
</div>